<script>
import appConfig from "@/app.config";
export default {
  props: {
    game: {
      type: Object,
      default() {
        return {
          image: "",
        };
      },
    },
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
    };
  },
  methods: {
    getImgUrl(img) {
      if (img) {
        if (img.indexOf("http") > -1) {
          return img;
        }
        return this.assetsPath + "images/" + img;
      }
      return "";
    },
  },
};
</script>

<template>
  <div :style="$style.gamePhotoCard" class="d-inline-block">
    <img style="border-radius: 30px" :src="getImgUrl(game.image)" />
  </div>
</template>

<style lang="scss" module>

@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.d-inline-block {
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  padding-bottom: 100%;
  img {
    border-radius: 30px;
    position: absolute;
    width: 100%;
    object-fit: cover;
    left: 0;
    top: 0;
    right: 0;
  }
}
</style>
